import { createReducer, on } from '@ngrx/store';
import { initialFinishState } from './finish_state';
import { finish } from './finish_actions_creator';

export const finishReducer = createReducer(
  initialFinishState,
  on(finish, (state, action) => ({...state, ...action.payload}))
);
